export const setFormDefaults = (formDiv : Element) => {
  const form = formDiv.querySelector('form');
  const formId = form.getAttribute('data-leadform-id') ?? 0;
  const urlParams = new URLSearchParams(window.location.search);

  if (!form) {
    return;
  }

  setWindowDefaults(form, formId);
  setDataAttributeDefaults(formDiv, formId);

  setUtmTrackingFields(form);
  setAgentIdField(form);
};

const setWindowDefaults = (form, formId) => {
  if (typeof window.formDefaults === 'undefined') {
    return;
  }

  for (const fieldName in window.formDefaults) {
    setFormField(form, fieldName, window.formDefaults[fieldName], formId);
  }
};
const setDataAttributeDefaults = (formDiv : Element, formId) => {
  if (!formDiv.hasAttribute('data-defaults')) {
    return;
  }

  const form = formDiv.querySelector('form');
  const dataDefaults = JSON.parse(formDiv.getAttribute('data-defaults'));
  const dataDefaultsLowercase = Object.keys(dataDefaults).reduce((acc, key) => {
    acc[key.toLowerCase()] = dataDefaults[key];
    return acc;
  }, {});

  if (typeof dataDefaults !== 'object') {
    return;
  }

  for (const fieldName in dataDefaultsLowercase) {
    const fieldNameLowercase = fieldName.toLowerCase();
    setFormField(form, fieldNameLowercase, dataDefaultsLowercase[fieldNameLowercase], formId);
  }
};

const setUtmTrackingFields = (form : Element) => {
  const trackingFields = ['campaign', 'content', 'medium', 'source', 'term'];
  const urlParams = new URLSearchParams(window.location.search);

  trackingFields.forEach((utm) => {
    if (urlParams.has(`utm_${utm}`)) {
      const field = form.querySelector(`[data-name=utm_${utm}]`);
      if (field !== undefined && field !== null) {
        field.setAttribute('value', urlParams.get(`utm_${utm}`) as string);
      } else {
        console.error(`Form field not found for query parameter: utm_${utm}`);
      }
    }
  });
};

const setAgentIdField = (form : Element) => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('agent')) {
    const field = form.querySelector('[data-name=agent_cloudwall_person_id]');
    if (field !== undefined && field !== null) {
      field.setAttribute('value', urlParams.get('agent') as string);
    } else {
      console.error('Form field not found for query parameter: agent');
    }
  }
};

const setFormField = (form : Element, fieldName : string, value, formId : string | number) => {
  let targetEl;
  let formField = true;
  let fieldVal = value;
  const priorityField = form.querySelector('[data-leadfield="priority"]');

  // Sanitize the value
  if (fieldVal == null) {
    fieldVal = '';
  }
  fieldVal = fieldVal.replace(/&amp;/g, '&');

  // Handle special cases
  if (fieldName == 'submit') {
    targetEl = form.querySelector('input[type=submit]');
  } else if (fieldName == 'intro-text' || fieldName == 'bottom-text') {
    targetEl = form.querySelector(`.${fieldName}`);
    formField = false;
  } else {
    targetEl = form.querySelector(`[data-name="${fieldName}" i]`);
  }

  // Create a hidden field to store the value being requested, if not found.
  if (targetEl === undefined || targetEl === null) {
    const hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', fieldName);
    hiddenInput.setAttribute('value', fieldVal);
    form.appendChild(hiddenInput);
    return;
  }

  // Render as-is, if not a form field.
  if (!formField) {
    targetEl.innerHTML = fieldVal;
    return;
  }

  if (targetEl.type.includes('select')) {
    // Different default setter for select boxes
    const selectOption = targetEl.querySelector(`option[value="${fieldVal}"]`);
    if (selectOption !== undefined && selectOption !== null) selectOption.selected = 'selected';

    // Special case to handle setting priority based on another field (WEB-6438)
    const statusPriority = targetEl.querySelector('option:checked');
    if (statusPriority !== undefined && statusPriority !== null) {
      if (statusPriority.dataset.priority !== undefined) {
        priorityField?.setAttribute('value', statusPriority.dataset.priority);
      }
    }
  } else if (targetEl.type === 'checkbox') {
    // checkboxes should have multiple choices and are double colon `::` separated values in ELQ Merge fields
    const checkboxVals = fieldVal.split('::');
    for (const cid in checkboxVals) {
      const cVal = checkboxVals[cid];
      jQuery(`:checkbox[name="${fieldName}"][value="${cVal}"]`).prop('checked', true).change();
    }
  } else if (targetEl.type === 'submit') {
    // Set the text of the submit button
    targetEl.value = fieldVal;
  } else if (targetEl.type === 'radio') {
    // Check the radio button with the matching value
    jQuery(`input[type=radio][value="${fieldVal}"]`).prop('checked', true).change();
  } else {
    // Set value on other <input>s with value attributes (text, hidden, etc)
    jQuery(targetEl).val(fieldVal).change();
  }
};
